export const TypeBadge = ({ type }: { type: string }) => (
  <span className="text-dark bg-secondary rounded-3xl px-2 py-1 text-center text-xs font-medium leading-[14px] tracking-normal">
    {type}
  </span>
);
